export const TUTOR_MESSAGE_MAX_LENGTH = 1000;
